import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=1f0f12ea&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=1f0f12ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f12ea",
  null
  
)

export default component.exports